import React, { useState } from 'react';
import logo3F from '../assets/logo3F.jpg';

export default function EcranConnexion({ onConnecter, loading, erreur, onOuvrirConfig }) {
  const [numero, setNumero]     = useState(() => localStorage.getItem('3f_saved_num') || '');
  const [password, setPassword] = useState(() => localStorage.getItem('3f_saved_pwd') || '');
  const [voirMdp, setVoirMdp]   = useState(false);
  const [aide, setAide]         = useState(false);
  const [remember, setRemember] = useState(() => !!localStorage.getItem('3f_saved_num'));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!numero.trim() || !password) return;
    if (remember) {
      localStorage.setItem('3f_saved_num', numero.trim());
      localStorage.setItem('3f_saved_pwd', password);
    } else {
      localStorage.removeItem('3f_saved_num');
      localStorage.removeItem('3f_saved_pwd');
    }
    onConnecter(numero, password);
  };

  return (
    <div style={styles.fond}>
      <div style={styles.haut}>

        {/* Logo */}
        <div style={styles.logoWrap}>
          <img src={logo3F} alt="Les Usagers de 3F Yvelines" style={styles.logo} />
        </div>

        {/* Textes */}
        <h1 style={styles.titre}>Les Usagers de 3F Yvelines</h1>
        <p style={styles.sousTitre}>Association de défense et de solidarité</p>
        <span style={styles.badge}>Espace adhérents</span>

      </div>

      <div style={styles.carte}>
        <div style={styles.carteEntete}>
          <span style={{ fontSize: '1.5rem' }}>🔐</span>
          <div>
            <div style={styles.carteTitre}>Accès réservé aux adhérents</div>
            <div style={styles.carteSous}>Connectez-vous avec vos identifiants</div>
          </div>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>

          <div style={styles.field}>
            <label style={styles.label}>Numéro d'adhérent</label>
            <input
              style={styles.input}
              type="text"
              placeholder="Ex : UY3F2026XXXXXXXX"
              value={numero}
              onChange={e => setNumero(e.target.value)}
              autoComplete="username"
              autoCapitalize="characters"
              disabled={loading}
            />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Mot de passe</label>
            <div style={styles.inputWrap}>
              <input
                style={{ ...styles.input, paddingRight: '2.8rem' }}
                type={voirMdp ? 'text' : 'password'}
                placeholder="Votre mot de passe"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                disabled={loading}
              />
              <button
                type="button"
                style={styles.oeilBtn}
                onClick={() => setVoirMdp(!voirMdp)}
                tabIndex={-1}
              >
                {voirMdp ? '🙈' : '👁'}
              </button>
            </div>
          </div>

          {/* Se souvenir de moi */}
          <div style={styles.rememberRow}>
            <input
              type="checkbox"
              id="remember"
              checked={remember}
              onChange={e => setRemember(e.target.checked)}
              style={{ cursor: 'pointer', width: 16, height: 16, accentColor: '#1a3a5c' }}
            />
            <label htmlFor="remember" style={styles.rememberLabel}>
              Se souvenir de moi
            </label>
          </div>

          {erreur && <div style={styles.erreur}>❌ {erreur}</div>}

          <button
            type="submit"
            style={{ ...styles.btnSubmit, opacity: (loading || !numero || !password) ? .6 : 1 }}
            disabled={loading || !numero.trim() || !password}
          >
            {loading
              ? <span style={styles.loadingRow}><span style={styles.spinner} /> Vérification…</span>
              : '→ Accéder au chatbot'
            }
          </button>
        </form>

        <button style={styles.btnAide} onClick={() => setAide(!aide)}>
          {aide ? '▲ Masquer' : '? Je ne connais pas mes identifiants'}
        </button>

        {aide && (
          <div style={styles.aideBloc}>
            <p style={styles.aideTxt}>
              Votre <strong>numéro d'adhérent</strong> vous a été communiqué par email lors de votre adhésion (format UY3F2026XXXXXXXX).
            </p>
            <p style={styles.aideTxt}>
              Pour récupérer vos identifiants, contactez le bureau :<br />
              <strong>asso.lesyvelines91160@gmail.com</strong>
            </p>
          </div>
        )}
      </div>

      <div style={styles.footer}>
        <button style={styles.btnAdmin} onClick={onOuvrirConfig}>⚙️ Admin</button>
        <span style={styles.footerTxt}>Accès sécurisé · Données protégées</span>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes fadeIn { from { opacity:0; transform:translateY(12px); } to { opacity:1; transform:translateY(0); } }
      `}</style>
    </div>
  );
}

const styles = {
  fond: {
    width: '100%', height: '100%',
    background: 'linear-gradient(160deg, #1a3a5c 0%, #2a5080 50%, #1a3a5c 100%)',
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', padding: '1.5rem 1rem', gap: '1.2rem',
    overflowY: 'auto',
  },
  haut: { textAlign: 'center', animation: 'fadeIn .4s ease' },
  logoWrap: {
    width: 90, height: 90,
    borderRadius: 20,
    background: '#fff',
    padding: 6,
    margin: '0 auto .8rem',
    boxShadow: '0 4px 16px rgba(0,0,0,.2)',
  },
  logo: {
    width: '100%', height: '100%',
    objectFit: 'contain',
    borderRadius: 14,
  },
  titre: { color: '#fff', fontSize: '1.2rem', fontWeight: 700, margin: 0 },
  sousTitre: { color: '#ff4444', fontSize: '.82rem', margin: '.2rem 0 .5rem', fontWeight: 600 },
  badge: {
    display: 'inline-block', background: 'rgba(255,255,255,.15)',
    border: '1px solid rgba(255,255,255,.25)', color: '#fff',
    fontSize: '.75rem', fontWeight: 600, padding: '.3rem .9rem', borderRadius: 20,
  },
  carte: {
    width: '100%', maxWidth: 400, background: '#fff',
    borderRadius: 20, padding: '1.5rem',
    boxShadow: '0 8px 32px rgba(0,0,0,.25)',
    animation: 'fadeIn .5s ease .1s both',
  },
  carteEntete: { display: 'flex', alignItems: 'center', gap: '.8rem', marginBottom: '1.2rem' },
  carteTitre: { fontWeight: 700, fontSize: '.95rem', color: '#1a3a5c' },
  carteSous: { fontSize: '.75rem', color: '#888', marginTop: '.1rem' },
  form: { display: 'flex', flexDirection: 'column', gap: '.9rem' },
  field: { display: 'flex', flexDirection: 'column', gap: '.3rem' },
  label: { fontSize: '.72rem', fontWeight: 600, color: '#666', textTransform: 'uppercase', letterSpacing: '.06em' },
  input: {
    width: '100%', padding: '.7rem .9rem',
    border: '1.5px solid #e0e0e0', borderRadius: 10,
    fontSize: '.92rem', fontFamily: 'Inter, sans-serif',
    color: '#111', outline: 'none', background: '#fafafa',
  },
  inputWrap: { position: 'relative' },
  oeilBtn: {
    position: 'absolute', right: '.7rem', top: '50%', transform: 'translateY(-50%)',
    background: 'none', border: 'none', cursor: 'pointer', fontSize: '1rem', padding: 0,
  },
  rememberRow: {
    display: 'flex', alignItems: 'center', gap: '.5rem',
  },
  rememberLabel: {
    fontSize: '.82rem', color: '#555', cursor: 'pointer', userSelect: 'none',
  },
  erreur: {
    background: '#fee2e2', color: '#991b1b',
    padding: '.6rem .8rem', borderRadius: 8, fontSize: '.8rem',
  },
  btnSubmit: {
    padding: '.8rem', background: '#1a3a5c', color: '#fff',
    border: 'none', borderRadius: 10, fontSize: '.92rem',
    fontWeight: 700, fontFamily: 'Inter, sans-serif', cursor: 'pointer',
  },
  loadingRow: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '.5rem' },
  spinner: {
    width: 16, height: 16, display: 'inline-block',
    border: '2px solid rgba(255,255,255,.3)', borderTop: '2px solid #fff',
    borderRadius: '50%', animation: 'spin .8s linear infinite',
  },
  btnAide: {
    background: 'none', border: 'none', cursor: 'pointer', color: '#1a3a5c',
    fontSize: '.78rem', fontFamily: 'Inter, sans-serif',
    marginTop: '.8rem', textDecoration: 'underline',
    display: 'block', width: '100%', textAlign: 'center', padding: 0,
  },
  aideBloc: {
    background: '#f0f4f8', borderRadius: 8, padding: '.8rem',
    marginTop: '.6rem', borderLeft: '3px solid #1a3a5c',
  },
  aideTxt: { fontSize: '.8rem', color: '#444', lineHeight: 1.6, marginBottom: '.4rem' },
  footer: { display: 'flex', alignItems: 'center', gap: '.8rem' },
  btnAdmin: {
    background: 'rgba(255,255,255,.1)', border: '1px solid rgba(255,255,255,.2)',
    color: 'rgba(255,255,255,.6)', fontSize: '.72rem',
    padding: '.3rem .6rem', borderRadius: 6, cursor: 'pointer', fontFamily: 'Inter, sans-serif',
  },
  footerTxt: { color: 'rgba(255,255,255,.4)', fontSize: '.68rem' },
};
